export default {"src":"/_next/static/media/report.0129fe0d.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};